import { createSlice } from "@reduxjs/toolkit";

const search = createSlice({
  name: "search",
  initialState: {
    query: "",
    entityType: [] as any,
    courseType: [] as any,
    packageType: 0,
    fromPrice: 0,
    toPrice: 100000000,
    courseCategoryIds: [],
    teacherIds: [],
    certificateIds: [],
    sortBy: 1,
    pageNumber: 1,
  } as any,
  reducers: {
    setFilterList(state, { payload: { checked, value, key, type } }) {
      if (key == "courseCategoryIds") {
        if (checked) {
          state[key] = [...state[key], value];
        } else {
          state[key] = state[key].filter((a: any) => a?.id !== value?.id);
        }
      } else {
        if (checked) {
          state[key] = [...state[key], value.id];
        } else {
          state[key] = state[key].filter((a: any) => a !== value.id);
        }
      }
    },
    resetFilters(state) {
      state.query = "";
      state.entityType = [] as any;
      state.courseType = [] as any;
      state.packageType = 0;
      state.fromPrice = 0;
      state.toPrice = 100000000;
      state.courseCategoryIds = [];
      state.teacherIds = [];
      state.certificateIds = [];
      state.sortBy = 1;
      state.pageNumber = 1;
    },
    setPrice(state, { payload }) {
      state.fromPrice = payload.min;
      state.toPrice = payload.max;
    },
    setCourseType(state, { payload }) {
      state.courseType = [payload];
    },
    setSortBy(state, { payload }) {
      state.sortBy = payload;
    },
    setFilterQuery(state, { payload }) {
      state.query = payload.query;
    },
    setPageNumber(state, { payload }) {
      state.pageNumber = payload.pageNumber;
    },
  },
});

export const {
  setFilterList,
  setSortBy,
  setCourseType,
  setFilterQuery,
  setPrice,
  resetFilters,
  setPageNumber,
} = search.actions;

export default search.reducer;
